import { render } from "./FilterBar.vue?vue&type=template&id=3404a3e7"
import script from "./FilterBar.vue?vue&type=script&lang=js"
export * from "./FilterBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/kraiburg-website-typo3/extensions/products/Resources/Private/Vue/product-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__